interface RelatedSectionHeaderProps {
    title: string;
    count: number;
}

export const RelatedSectionHeader = ({
    title,
    count,
}: RelatedSectionHeaderProps) => (
    <div
        data-testid="related-section-header"
        className="mb-3 flex items-center gap-2"
    >
        <span className="text-muted-foreground/70 text-[0.65rem] font-bold tracking-[0.08em] uppercase">
            {title}
        </span>
        {count > 0 && (
            <span
                data-testid="related-section-count"
                className="bg-foreground/[0.04] text-muted-foreground/80 rounded px-1.5 py-px text-[0.65rem] leading-snug font-semibold tabular-nums"
            >
                {count}
            </span>
        )}
    </div>
);
